import { setDataDogUser } from '@/utils/config';
import { storeCreator } from '@/utils/store/store.utils';

import { UserModel } from '../user.types';

interface State {
  employeeId: string;
  organizationId: string;
  personId: string;
  auth: boolean;
  inited: boolean;
  user: UserModel | null;
  setAuth: (value: boolean) => void;
  setUser: (user: UserModel | null) => void;
  setIds: (employeeId?: string, organizationId?: string, personId?: string) => void;
}

const useStore = storeCreator<State>((set) => ({
  employeeId: '',
  organizationId: '',
  personId: '',
  auth: false,
  inited: false,
  user: null,
  setAuth: (value: boolean) =>
    set(() => ({
      auth: value,
      inited: true,
    })),
  setUser: (user: State['user']) =>
    set(() => {
      if (user && user.id) {
        setDataDogUser({
          id: user.id,
          employee_id: user?.employee?.id,
          person_id: user.id,
        });
      }
      return {
        user,
      };
    }),
  setIds: (employeeId: string = '', organizationId: string = '', personId: string = '') =>
    set(() => {
      // The JWT already carries the ids, so RUM gets the user as soon as the
      // token is known instead of waiting for the employee/organization queries.
      if (personId) {
        setDataDogUser({
          id: personId,
          employee_id: employeeId || undefined,
          person_id: personId,
        });
      }
      return {
        employeeId,
        organizationId,
        personId,
      };
    }),
}));

export default useStore;
